import styled from "styled-components"

const spacingCogWheel = "65px"

export const WidgetContainer = styled.div`
  background-color: ${props =>
    props.backgroundColor && props.activeBackground ? props.backgroundColor : ""};
  border-radius: ${props =>
    props.borderRadius && props.activeRadius ? props.borderRadius : "5px"};
  border-style: ${props =>
    props.borderStyle && props.activeBorder ? props.borderStyle : props.activeBorder && "solid"};
  border-color: ${props =>
    props.borderColor && props.activeBorder ? props.borderColor : props.activeBorder && "#000"};
  border-width: ${props =>
    props.borderSize && props.activeBorder ? props.borderSize : props.activeBorder && "0px"};
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const WidgetHeader = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ showTitle }) => (showTitle ? "space-between" : "flex-end")};
  min-height: ${({ showTitle }) => (showTitle ? "50px" : "0px")};
  max-height: ${({ showTitle }) => (showTitle ? "20%" : "0%")};
`

export const ButtonSettings = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 8.5px 0;
  z-index: 2;
  position: ${({ showTitle }) => (showTitle ? "relative" : "absolute")};
  top: 0px;
  .loading_container {
    height: 30px;
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    .success {
      font-size: 0.9rem;
      color: ${({ primaryActionColor }) => primaryActionColor};
    }

    .loading {
      color: ${({ primaryActionColor }) => primaryActionColor};
      font-size: 0.9rem;
      -webkit-animation: spin 4s linear infinite;
      -moz-animation: spin 4s linear infinite;
      animation: spin 4s linear infinite;
    }
    @-moz-keyframes spin {
      100% {
        -moz-transform: rotate(360deg);
      }
    }
    @-webkit-keyframes spin {
      100% {
        -webkit-transform: rotate(360deg);
      }
    }
    @keyframes spin {
      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  }
`

export const Title = styled.div`
  width: ${({ showWidgetConfigButton }) =>
    showWidgetConfigButton ? `calc(100% - ${spacingCogWheel})` : "100%"};
  padding: 10px 14px 8px 14px;
  letter-spacing: 0px;
  color: ${props => (props.labelColor ? props.labelColor : "#000000")};
  font-size: ${props => (props.labelSize ? `${props.labelSize} !important` : "1rem")};
  font-weight: ${props => (props.labelWeight ? props.labelWeight : "bold")};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: ${({ titleAlignement }) => (titleAlignement === "center" ? "center" : "")};
`

export const ChartContainer = styled.div`
  position: relative;
  padding: ${({ isFilter, isRedirectButton }) => (isFilter || isRedirectButton ? "0px" : "14px")};
  height: 100%;
  ${({ isFilter }) =>
    !isFilter &&
    `
    overflow: hidden;
  `}
  ${({ chartType }) =>
    chartType === "gaugeChart" &&
    `
    overflow: initial !important;
  `}

  .amcharts-ampopup-content {
    z-index: 500;
  }

  .amcharts-ampopup-curtain {
    z-index: 502;
  }
`

export const ConfigurationContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: calc(100% - 10px);
  width: 100%;
  background-color: #ffffff77;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
`

export const EmptyWidgetContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: #ffffff;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ErrorWidgetContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  svg {
    height: 100px;
    padding-bottom: 15px;
  }
`
